<div class="filter-item">
  <a mat-button class="primary-menu-button" [matMenuTriggerFor]="saleTypeFilter">
    <span class="pr-2" [class.primary-color]="!allSaleTypesSelected">{{ menuLabel }}</span>
    <mat-icon iconPositionEnd class="menu-expand-icon">arrow_drop_down</mat-icon>
  </a>

  <mat-menu #saleTypeFilter="matMenu" (closed)="onMenuClosed($event)">
    <div>
      <div class="ml-3"><b>Sale Type</b></div>

      <button mat-menu-item (click)="$event.stopPropagation()">
        <mat-checkbox
          color="primary"
          class="primary-checkbox"
          [checked]="saleTypeSelection.isEmpty()"
          (change)="toggleAllSaleTypes($event.checked)">
          All
        </mat-checkbox>
      </button>

      @for (st of saleTypes; track st.id) {
        <button mat-menu-item (click)="$event.stopPropagation()">
          <mat-checkbox
            color="primary"
            class="primary-checkbox"
            [checked]="isSaleTypeChecked(st)"
            (change)="toggleSaleType(st)">
            {{ st.name }}
          </mat-checkbox>
        </button>
      }
    </div>

    <div class="flex-row space-between items-center px-2 py-2 sticky">
      <a color="primary" mat-button (click)="onClearClick()">Clear</a>
      <button mat-flat-button color="primary" mat-button (click)="onApplyClick()">Apply</button>
    </div>
  </mat-menu>
</div>